import React, { useState } from 'react';
import './Technical.css';

const Technical = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (category) => {
    setOpenDropdown(openDropdown === category ? null : category);
  };

  return (
    <div className="technical-wrapper" id="technical">
      <h1 className="technical-title">Technical Skills</h1>

      {/* Programming Languages */}
      <div className="dropdown">
        <button
          className="dropdown-toggle"
          onClick={() => toggleDropdown('languages')}
          aria-expanded={openDropdown === 'languages'}
        >
          Programming Languages {openDropdown === 'languages' ? '▲' : '▼'}
        </button>
        {openDropdown === 'languages' && (
          <ul className="dropdown-list">
            <li>JavaScript</li>
            <li>HTML</li>
            <li>CSS</li>
            <li>Python</li>
            <li>Java</li>
            <li>C++</li>
            <li>Assembly</li>
          </ul>
        )}
      </div>

      {/* Frameworks */}
      <div className="dropdown">
        <button
          className="dropdown-toggle"
          onClick={() => toggleDropdown('frameworks')}
          aria-expanded={openDropdown === 'frameworks'}
        >
          Frameworks & Libraries {openDropdown === 'frameworks' ? '▲' : '▼'}
        </button>
        {openDropdown === 'frameworks' && (
          <ul className="dropdown-list">
            <li>React</li>
            <li>Node.js</li>
            <li>Express</li>
            <li>Pandas</li>
            <li>NumPy</li>
            <li>PyTorch</li>
            <li>JavaFx</li>
          </ul>
        )}
      </div>

      {/* Tools & Platforms */}
      <div className="dropdown">
        <button
          className="dropdown-toggle"
          onClick={() => toggleDropdown('tools')}
          aria-expanded={openDropdown === 'tools'}
        >
          Tools & Platforms {openDropdown === 'tools' ? '▲' : '▼'}
        </button>
        {openDropdown === 'tools' && (
          <ul className="dropdown-list">
            <li>Git & GitHub</li>
            <li>Docker</li>
            <li>AWS</li>
            <li>Jira</li>
            <li>Microsoft Office Tools</li>
            <li>Visual Studio Code</li>
            <li>Jupyter Notebook</li>
            <li>MongoDB</li>
            <li>Google Cloud Platform</li>
            <li>Microsoft Azure</li>
            <li>Kubernetes</li>
          </ul>
        )}
      </div>

      {/* Communication Platforms */}
<div className="dropdown">
  <button
    className="dropdown-toggle"
    onClick={() => toggleDropdown('communicationPlatforms')}
    aria-expanded={openDropdown === 'communicationPlatforms'}
  >
    Communication Platforms {openDropdown === 'communicationPlatforms' ? '▲' : '▼'}
  </button>
  {openDropdown === 'communicationPlatforms' && (
    <ul className="dropdown-list">
      <li>Microsoft Teams</li>
      <li>Zoom</li>
      <li>Discord</li>
    </ul>
  )}
</div>


      {/* Workplace Skills */}
<div className="dropdown">
  <button
    className="dropdown-toggle"
    onClick={() => toggleDropdown('workplaceSkills')}
    aria-expanded={openDropdown === 'workplaceSkills'}
  >
    Workplace Skills {openDropdown === 'workplaceSkills' ? '▲' : '▼'}
  </button>
  {openDropdown === 'workplaceSkills' && (
    <ul className="dropdown-list">
      <li>Strong Time Management</li>
      <li>Strong Team Collaboration</li>
      <li>Strong Communication</li>
      <li>High-Level Problem Solver</li>
      <li>Agile Methodologies</li>
      <li>Adaptable and Flexible</li>
      <li>Critical Thinker</li>
      <li>Strong Work Ethic</li>
    </ul>
  )}
</div>

    </div>
  );
};

export default Technical;
